import { Component, ElementRef, OnInit } from '@angular/core';
import posthog from 'posthog-js';
import { ViewOffersService } from '../../../view-offers/services/view-offers.service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
})
export class MaintenanceBannerComponent implements OnInit {
  bannerConfig:
    | {
        startTime: string;
        endTime: string;
        startDate: string;
        endDate: string;
        bannerStartDate: string;
        bannerStartTime: string;
        bannerMessage?: string;
        bannerSubMessage?: string;
        bannerThirdMessage?: string;
      }
    | undefined;

  showBanner = false;
  constructor(
    private elementRef: ElementRef,
    private viewOffersService: ViewOffersService
  ) {}

  ngOnInit(): void {
    this.viewOffersService.offersLoaded$.subscribe((loaded) => {
      if (loaded) {
        posthog.onFeatureFlags(() => {
          this.determineIfShouldShowBanner();
        });
      }
    });
  }

  determineIfShouldShowBanner(): void {
    this.bannerConfig = posthog.getFeatureFlagPayload(
      'maintenance-banner'
    ) as any;

    if (!this.bannerConfig) {
      this.closeBanner();
      return;
    }

    const startTime = new Date(this.bannerConfig.bannerStartDate);
    startTime.setHours(
      parseInt(this.bannerConfig.bannerStartTime.split(':')[0])
    );
    startTime.setMinutes(
      parseInt(this.bannerConfig.bannerStartTime.split(':')[1])
    );

    const endTime = new Date(this.bannerConfig.endDate);
    endTime.setHours(parseInt(this.bannerConfig.endTime.split(':')[0]));
    endTime.setMinutes(parseInt(this.bannerConfig.endTime.split(':')[1]));

    const isAfterStartTime = new Date().getTime() > startTime.getTime();
    const isBeforeEndTime = new Date().getTime() < endTime.getTime();

    if (isAfterStartTime && isBeforeEndTime) {
      console.log('showing banner');
      this.showBanner = true;
    } else {
      console.log('not showing banner');
      this.closeBanner();
    }
  }

  closeBanner() {
    this.elementRef.nativeElement.remove();
  }
}
